import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ReactiveDialogContentComponent } from '@app/shared/components/dialog/reactive-dialog/base/reactive-dialog-content/reactive-dialog-content.component';
import { AbstractReactiveDialogComponent } from '../reactive-dialog/base/abstract-reactive-dialog-component';

@Component({
  selector: 'app-gsm-virus-warning-dialog',
  templateUrl: './gsm-virus-warning-dialog.component.html',
  styleUrls: ['./gsm-virus-warning-dialog.component.scss'],
  standalone: true,
  imports: [
    ReactiveDialogContentComponent,
    MatIcon,
    MatButton
  ]
})
export class GsmVirusWarningDialogComponent extends AbstractReactiveDialogComponent<string, undefined> {
}
